import * as XLSX from 'xlsx';

export const convertSheetToJson = (file, callback) => {
    const reader = new FileReader()

    reader.onload = (evt) => {
        const bstr = evt.target.result;
        const workbook = XLSX.read(bstr, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        return callback(jsonData)
    }

    reader.readAsArrayBuffer(file)
}